import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { ANY_SPORT_MY_CARDS } from 'constants/__generated__/routes';
import { useSeriesNav } from 'hooks/commonGame/useSeriesNav';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { matchAnySportPath } from 'lib/routing/generateSportPath';

export const useEnableSeriesNavigationUpdate = () => {
  const seriesNav = useSeriesNav();
  const { pathname } = useLocation();
  const isMyCards = matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS), pathname);
  const {
    // flag to control series-related navigation updates
    // but not restricted to simplified nav users (header, my cards changes, etc.)
    flags: { enableSeriesNavigationUpdate = false },
  } = useFeatureFlags();
  return seriesNav || (enableSeriesNavigationUpdate && isMyCards);
};
